export interface RelatedTitle {
  id: number;
  title: string;
  genre: string;
  year: string;
  poster: string;
  synopsis: string;
  detail: string;
  episodes: string;
  tags: string[];
}

export const relatedTitles: RelatedTitle[] = [
  {
    id: 1,
    title: "雾隐山庄",
    genre: "悬疑 · 年代",
    year: "2025",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20mysterious%20poster%20of%20a%20misty%20old%20mountain%20villa%20at%20night%20with%20a%20faint%20warm%20window%20light%2C%20deep%20blue%20and%20black%20tones%20with%20subtle%20gold%20accents%2C%20dramatic%20film%20poster%20style%2C%20muted%20cold%20tones%2C%20highly%20detailed%20cinematic%20composition&width=600&height=900&seq=wuyan-rel-01&orientation=portrait",
    synopsis: "一座被浓雾封锁的山庄，一位不请自来的客人，一桩四十年前的旧案在雨夜重新翻开。",
    detail: "以密闭空间推理见长的年代悬疑剧，节奏沉稳、氛围阴郁，通过层层反转揭开山庄主人刻意隐藏的家族往事，与《无颜之月》同样注重时间与记忆的主题。",
    episodes: "全 16 集",
    tags: ["密闭空间", "家族往事", "冷色调"],
  },
  {
    id: 2,
    title: "白鸟之诗",
    genre: "爱情 · 奇幻",
    year: "2024",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20elegant%20poster%20of%20a%20lone%20white%20bird%20in%20flight%20against%20a%20dark%20navy%20moonlit%20sky%20with%20soft%20gold%20glow%2C%20dreamy%20romantic%20mysterious%20atmosphere%2C%20deep%20blue%20tones%2C%20highly%20detailed%20cinematic%20composition&width=600&height=900&seq=wuyan-rel-02&orientation=portrait",
    synopsis: "每到月圆之夜，死去的人可以化身为白鸟归来一次。她等了三年，只为再见他一面。",
    detail: "唯美细腻的奇幻爱情故事，用一只白鸟串联起跨越生死的思念。画面诗意、情绪克制，适合喜欢《无颜之月》中那份温柔与遗憾的观众。",
    episodes: "全 12 集",
    tags: ["生死之恋", "唯美", "治愈"],
  },
  {
    id: 3,
    title: "旧镜",
    genre: "惊悚 · 悬疑",
    year: "2025",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20eerie%20poster%20of%20a%20cracked%20antique%20mirror%20reflecting%20a%20blurred%20figure%20in%20a%20dim%20room%2C%20cold%20moonlight%2C%20deep%20blue%20and%20black%20tones%20with%20subtle%20gold%20frame%20detail%2C%20mysterious%20horror%20film%20poster%20style%2C%20highly%20detailed&width=600&height=900&seq=wuyan-rel-03&orientation=portrait",
    synopsis: "她买下一面旧镜子，镜中的世界却比她所在的房间，早醒了一天。",
    detail: "以“镜像即另一个时空”为核心概念的心理惊悚剧，善于用声音与光影制造压迫感，与《无颜之月》共享一套冷静而克制的美学。",
    episodes: "全 10 集",
    tags: ["心理惊悚", "时空错位", "压迫感"],
  },
  {
    id: 4,
    title: "灯下故人",
    genre: "剧情 · 年代",
    year: "2024",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20warm%20nostalgic%20poster%20of%20a%20single%20oil%20lamp%20on%20a%20wooden%20table%20with%20a%20faded%20photograph%2C%20deep%20blue%20shadows%20with%20warm%20gold%20light%2C%20quiet%20emotional%20mood%2C%20muted%20tones%2C%20highly%20detailed%20cinematic%20composition&width=600&height=900&seq=wuyan-rel-04&orientation=portrait",
    synopsis: "老照相馆的最后一位师傅，用一盏灯、一台旧相机，为街坊留下了半座城市的记忆。",
    detail: "慢节奏的年代群像剧，以细水长流的叙事记录普通人的告别与重逢。气质温润，与《无颜之月》中关于“记住”的主题遥相呼应。",
    episodes: "全 24 集",
    tags: ["年代群像", "温情", "记忆"],
  },
  {
    id: 5,
    title: "深蓝回声",
    genre: "科幻 · 悬疑",
    year: "2026",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20abstract%20poster%20of%20deep%20underwater%20light%20beams%20and%20floating%20particles%2C%20deep%20cold%20blue%20gradient%20with%20faint%20gold%20shimmer%2C%20dreamlike%20mysterious%20sci-fi%20film%20poster%20style%2C%20muted%20tones%2C%20highly%20detailed&width=600&height=900&seq=wuyan-rel-05&orientation=portrait",
    synopsis: "深海观测站接收到一段来自三十年前的求救信号，而发信人，正是站长本人。",
    detail: "硬科幻外壳下包裹着关于孤独与救赎的悬疑故事，冷峻的蓝色调与精密的结构呼应《无颜之月》的沉静气质。",
    episodes: "全 8 集",
    tags: ["深海", "时间悖论", "冷峻"],
  },
  {
    id: 6,
    title: "纸门之外",
    genre: "剧情 · 奇幻",
    year: "2025",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20dark%20navy%20poetic%20poster%20of%20a%20rice-paper%20sliding%20door%20with%20a%20shadow%20of%20a%20figure%20behind%20it%20and%20soft%20moonlight%2C%20deep%20blue%20tones%20with%20subtle%20gold%20glow%2C%20mysterious%20elegant%20atmosphere%2C%20highly%20detailed%20cinematic%20composition&width=600&height=900&seq=wuyan-rel-06&orientation=portrait",
    synopsis: "一扇永远推不开的纸门，后面住着她已经离开的家人，也住着她不敢面对的过去。",
    detail: "诗意的奇幻小品，用一扇纸门连接现实与记忆。情感内敛、画面讲究，是《无颜之月》观众会喜欢的另一部“温柔悬念”之作。",
    episodes: "全 12 集",
    tags: ["记忆", "诗意", "内敛"],
  },
];